//import { ReorderUI } from "@/ui-sdk/ui-script/reorder-ui";
import { ReorderUI } from "@/ui-sdk/ui-script/reorder-ui";
import {
  Banner,
  Collection,
  Product,
  ProductImage,
  Section,
  TextItem,
} from "../types";

export class Reorder {
  static reorder({
    type,
  }: {
    type:
      | "section"
      | "text"
      | "banner"
      | "productImages"
      | "productList"
      | "collectionList";
  }) {
    switch (type) {
      case "section":
        // return this.sections(data as Section[]);
        return null;
      case "text":
        // return this.textItems(data as TextItem[]);
        return null;
      case "banner":
        // return Reorder.banners(data as Banner[]);
        return null;
      case "productImages":
        // return Reorder.productImages(data as ProductImage[]);
        return null;
      case "productList":
        return Reorder.products();
      case "collectionList":
        // return Reorder.collections(data as Collection[]);
        return null;
      default:
        throw new Error("Unknown reorder type");
    }
  }
  static sections(sections: Section[]): Section[] {
    return sections;
  }
  static texts(textItems: TextItem[]): TextItem[] {
    return textItems;
  }
  static banners(banners: Banner[]): Banner[] {
    return banners;
  }
  static productImages(productImages: ProductImage[]): ProductImage[] {
    return productImages;
  }
  static async products(): Promise<void> {
    let isLoading = true;
    try {
      const searchParams = new URLSearchParams(window.location.search);
      const filterKeys: Record<string, string> = {};
      searchParams.forEach((value, key) => {
        if (key.startsWith("s_")) {
          const newKey = key.replace("s_", "");
          filterKeys[newKey] = filterKeys[newKey]
            ? [...filterKeys[newKey], value]
            : [value];
        }
      });

      if (Object.keys(filterKeys).length === 0) {
        const originalList = document.querySelector(
          '[data-helium-name="product-list"]',
        );
        const filteredList = document.querySelector(
          '[data-helium-name="filtered-product-list"]',
        );
        if (originalList) originalList.style.display = "";
        if (filteredList) filteredList.style.display = "none";
        return;
      }

      // ReorderUI.productList({ isLoading });

      const productIds = await window.helium.datastore.search({
        filterKeys,
        ignoreHandle: "",
      });

      if (productIds.length === 0) {
        window.helium.datastore.memory.filters.products = [];
        isLoading = false;
        ReorderUI.productList({ isLoading });
        return;
      }

      const products = await Promise.all(
        productIds?.map(
          async (id: string) =>
            (await window.helium.datastore.getProduct({ id })).details,
        ),
      );

      window.helium.datastore.memory.filters.products = products;
      isLoading = false;
      ReorderUI.productList({ isLoading });
    } catch (error) {
      console.error("Error fetching products:", error);
      isLoading = false;
      ReorderUI.productList({ isLoading });
    }
  }
  static collections(collections: Collection[]): Collection[] {
    return collections;
  }
}
